import React, {useEffect, useLayoutEffect, useRef, useState} from 'react'
import Scrollbars from "react-custom-scrollbars";
import styled from "styled-components";
import {makeStyles} from "@material-ui/core/styles";
import useDesktop from "../../../components/Responsive/useDesktop";
import {useDispatch, useSelector} from "react-redux";
import {getAttributesByStep} from "../../../reducers/project/selectors";
import {IAttributes, Steps, Types} from "../../../reducers/project";
import {ProjectActions} from "../../../reducers/project/actionsNames";
import {groupBy} from "lodash";
import content from "../../../content";
import Attribute from "../../../components/Attributes/Attribute";

const a = [
    {
        id: 6,
        "name": "Koło A",
        price: "50.00",
        category: "kola",
        type: "select",
        pimg: "/static/v/kola.png",
        vimg: "/static/v/kola.glb",
        default: 0,
        value: 0,
        deleted: 0,
    },
    {
        id: 7,
        "name": "Koło B",
        price: "60.00",
        category: "kola",
        type: "select",
        pimg: "/static/v/kola2.png",
        vimg: "/static/v/kola2.glb",
        default: 0,
        value: 0,
        deleted: 0,
    },
    {
        id: 8,
        "name": "Niebieski",
        price: "0.00",
        category: "kola_kolor",
        type: "select",
        pimg: "/static/v/blue.png",
        vimg: 0x0000ff,
        default: 0,
        value: 0,
        deleted: 0,
    },
    {
        id: 9,
        "name": "Czerwony",
        price: "0.00",
        category: "kola_kolor",
        type: "select",
        pimg: "/static/v/red.png",
        vimg: 0xff0000,
        default: 0,
        value: 0,
        deleted: 0,
    },
    {
        id: 100,
        "name": "Zielony",
        price: "0.00",
        category: "kola_kolor",
        type: "select",
        pimg: "/static/v/green.png",
        vimg: 0x00ff00,
        default: 0,
        value: 0,
        deleted: 0,
    },
] as unknown as IAttributes[];

const Label = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 0.05em;
  color: white;
  opacity: 0.7;
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
`;

const WrapperHeader = styled.div<any>`
  width: ${({ step }) => (step ? "100%" : "calc(100% - 5px)")};
  display: flex;
  box-sizing: border-box;
  min-width: 0;
  justify-content: center;
  padding: 16px 0px;
  margin-left: ${({ step }) => (step ? "0" : "5px")};
`;

const Header = ({ name, step, bgcolor }) => {
    return (
        <WrapperHeader
            step={step === 0}
            style={{
                backgroundColor: bgcolor,
                borderRadius:
                    step === 3
                        ? "0px 4px 0px 0px"
                        : step === 0
                            ? "4px 0px 0px 0px"
                            : "unset",
            }}
        >
            <Label>{name}</Label>
        </WrapperHeader>
    );
};

const AttributesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 15px 0px;
`;

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    heading: {
        fontSize: "14px",
        fontWeight: 600,
        color: "black",
    },
    expansionHeader: {
        maxHeight: "40px",
        backgroundColor: "#F5F4F4",
        border: "1px solid #EAE5E5",
    },
    expansionHeaderExpanded: {
        minHeight: "40px !important",
    },
    expansionBody: {
        border: "1px solid #EAE5E5",
        backgroundColor: "white",
    },
}));

export const AttributeContainer = styled.div<{
    border: boolean;
    center: boolean;
}>`
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  justify-content: ${({ center }) => (center ? "center" : "start")};
  padding-top: 20px;
`;

export const AttributeHeader = styled.div`
  font-family: Inter;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #1e2029;
  padding: 15px 15px 15px 0;
  text-transform: capitalize;
  letter-spacing: -0.01em;
  border-bottom: 2px solid #efa21e;
`;

const Wrapper = styled.div<any>`
  height: 100%;
  background: white;
  padding: 0 0px 25px 25px;
  margin-left: ${({ step }) => (step ? "0" : "5px")};
  min-width: 0;
  box-sizing: border-box;

  @media (max-width: 1530px) {
    padding: 0 10px 10px 10px;
  }

  @media (max-width: 1023px) {
    padding: 0 18px 18px 18px;
  }
`;

const PaddingWrapper = styled.div`
  padding-right: 25px;

  @media (max-width: 1530px) {
    padding-right: 0px;
  }
`;

function Step1({    name,
                   pos,
                   expanded,
                   toggleExpand,
                   last,
                   onClick,
                   expandNext,
                   setScrollTop,
                   setScrollMax,
                   scrollTop,
                   scrollMax,
                   bgcolor,
                   step,}: any) {

    const [search, setSearch] = useState<string>("");
    const scrollRef = useRef<any>();

    const classes = useStyles();
    const desktop = useDesktop();

    const attributes = useSelector(
        getAttributesByStep((step as unknown) as Steps)
    );

    const dispatch = useDispatch();

    const onExpand = () => {
        if (toggleExpand) {
            toggleExpand(step as any);
        }
    };

    const selectAttr = (attr: IAttributes) => () => {
        if (onClick) {
            onClick(attr);
        }
        dispatch({ type: ProjectActions.SelectAttr, attr });
    };

    const attributesGrouped = groupBy(attributes, "category");

    useEffect(() => {
        if (scrollRef.current) {
            const scrollHeight = scrollRef.current.getScrollHeight();
            if (scrollHeight > scrollMax) {
                setScrollMax(scrollHeight);
            }
        }
    }, [scrollRef.current]);

    useLayoutEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop(scrollTop);
        }
    }, [scrollTop]);

    const onScroll = (values) => {
        setScrollTop(values.scrollTop);
    };

    const contents = <> <div>
        <AttributeHeader>Typ koła</AttributeHeader>
        <AttributeContainer
            center={false}
            border={false}
        >
            <div
                style={{
                    display: "flex",
                    minWidth: 0,
                    flexWrap: "wrap",
                    width:
                        "100%",
                }}
            >
                <Attribute onClick={selectAttr(a[0])} attr={a[0]} />
                <Attribute onClick={selectAttr(a[1])} attr={a[1]} />
            </div>
        </AttributeContainer>
    </div>
        <div>
            <AttributeHeader>Kolor Koła</AttributeHeader>
            <AttributeContainer
                center={false}
                border={false}
            >
                <div
                    style={{
                        display: "flex",
                        minWidth: 0,
                        flexWrap: "wrap",
                        width:
                            "100%",
                    }}
                >
                    <Attribute onClick={selectAttr(a[2])} attr={a[2]} />
                    <Attribute onClick={selectAttr(a[3])} attr={a[3]} />
                    <Attribute onClick={selectAttr(a[4])} attr={a[4]} />
                </div>
            </AttributeContainer>
        </div>
    </>

    return (
        <div
            style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
                boxSizing: "border-box",
                marginTop: "20px",
                minWidth: "0",
                marginLeft: step === 0 && desktop ? "20px" : "0",
            }}
        >
            <Header bgcolor={bgcolor} name={name} step={step} />
            <Wrapper step={step === 0}>
                {desktop && (
                    <Scrollbars
                        renderTrackVertical={step === 3 ? undefined : () => <div></div>}
                        hideTracksWhenNotNeeded={true}
                        autoHide={true}
                        onScrollFrame={onScroll}
                        ref={scrollRef}
                    >
                        <PaddingWrapper
                            style={{
                                height: scrollMax !== 0 ? scrollMax + "px" : "unset",
                            }}
                        >
                            {contents}
                        </PaddingWrapper>
                    </Scrollbars>
                )}
                {!desktop && <>{contents}</>}
            </Wrapper>
        </div>
    );
};

export default Step1